import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import { SegmentCardEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { EDropdownOptionsButtonSource } from '../../../components/CustomPropertiesForm/types';

export const onDropdownOptionsButton = (
    source: EDropdownOptionsButtonSource
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (source === EDropdownOptionsButtonSource.ADD) dispatch(segmentTrackAction(SegmentCardEvent.CUSTOM_PROPERTY_DROPDOWN_OPTION_ADD));
        if (source === EDropdownOptionsButtonSource.REMOVE) dispatch(segmentTrackAction(SegmentCardEvent.CUSTOM_PROPERTY_DROPDOWN_OPTION_REMOVE));
    };
    return action;
};
